<template>
  <div class="wrapper">
    <button data-modal-close @tap="cancel" @click="cancel">
        <img src="@/assets/images/close.svg" height="20" width="20" alt="close icon"/>
        <span class="visually-hidden">Close modal</span>
    </button>
    <div class="caption">{{caption}}</div>

    <a-input noLabel class="date-picker" type="custom">
      <select class="day" v-model="day" @focus="error = false">
        <option v-for="option in optionsDays" :key="option.value" :selected="option.value === day" :value="option.value">{{option.label}}</option>
      </select>
      <select class="month" v-model="month" @focus="error = false">
        <option v-for="option in optionsMonths" :key="option.value" :selected="option.value === month" :value="option.value">{{option.label}}</option>
      </select>
      <select class="year" v-model="year" @focus="error = false">
        <option v-for="option in optionsYears" :key="option.value" :selected="option.value === month" :value="option.value">{{option.label}}</option>
      </select>
     <!-- <input class="year" label="Jahr" v-model="year" type="number" />-->

    </a-input>
    <div v-bind:class="{'error': true, 'hidden': !error }">
        <div class="text">{{ age }}</div>
      </div>
    <div v-if="errorPuppy" class="error-gray">
      <div class="text">{{ errorPuppy }}</div>
    </div>
    <a-btn-set>
      <a-btn @tap="done" @click="done">OK</a-btn>
    </a-btn-set>

  </div>
</template>

<script>

import locale from '@/locales'
import {puppyEntry} from "../../vars";

export default {
  props: {
    caption: {
      type: String,
      default: '[caption]'
    },
    date: {
      default: () => new Date()
    },
    yeartype: {
      type: String,
      default: 'full'
    },
    race: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    object: new Date(),
    error: false,
    age: '',
    errorPuppy: false,
  }),
  computed: {
    optionsDays () {
      return Array.from({length: 31}, (v, i) => ({
        label: i + 1,
        value: i + 1
      }))
    },
    optionsMonths () {
      return Array.from(locale.monthNames, (label, value) => ({
        label,
        value
      }))
    },
    optionsYears () {

      //if (this.default == 'full') {
        let startyear = (new Date()).getFullYear()
        let red = 120

        if (this.yeartype == 'pet') {
          red = 11
        //  startyear = startyear -1
        }


        if (this.yeartype == 'hppet') {
          red = 20
        //  startyear = startyear -1
        }

        if (this.yeartype == 'adult') {
          startyear = startyear - 17
          red = 100
        }

        if (this.yeartype == 'start') {
          red = 2
          startyear = startyear +1
        }

        let end = startyear - red
        let year = []
        let y = 0;

        for (let i = startyear; i > end; i--) {
          year[y] = {label: i, value: i}
          y++;
        }
        return year
    //  }


    },
    year: {
      get () {
        return this.object.getFullYear()
      },
      set (value) {
        this.validate(parseInt(value) || 0, this.object.getMonth(), this.object.getDate())
      }
    },
    month: {
      get () {
        return this.object.getMonth()
      },
      set (value) {
        this.validate(this.object.getFullYear(), parseInt(value) || 0, this.object.getDate())
      }
    },
    day: {
      get () {
        return this.object.getDate()
      },
      set (value) {
        this.validate(this.object.getFullYear(), this.object.getMonth(), parseInt(value) || 1)
      }
    }
  },
  watch: {
    date: {
      immediate: true,
      handler (to) {
        if (to instanceof Date) {
          this.object = to
        } else if (typeof to === 'string') {
          this.object = new Date(to)
        } else {
          this.object = new Date()
        }
      }
    },
    object: {
      handler (to) {
        if (puppyEntry && (this.yeartype == 'pet' || this.yeartype == 'hppet')) {
          let seconds = this.calcAgeInSeconds(to)
          // 6 months
          if (seconds > 15780000) {
            this.errorPuppy = 'Tier zu alt für das Willkommenspaket.'
          } else {
            this.errorPuppy = false
          }
        }
      }
    },
  },
  methods: {
    validate (year, month, day) {
      let date = new Date()
      let check = () => {
        date.setFullYear(year)
        date.setMonth(month, day)

        if (date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day) {
          --day

          check()
        }
      }

      check()

      this.object = date
    },
    done () {
      if (this.yeartype == 'pet' || this.yeartype == 'hppet') {
        var today = new Date();

        if(today - 4838401000 < this.object-0) {
          this.age = 'Das Tier muss min. 8 Wochen alt sein.'
          this.error = true
          return false
        }

      }

      this.$emit('done', this.object)
    },
    cancel () {
      this.$emit('done')
    }
  }
}

</script>

<style lang="scss" scoped>

.wrapper {
  .caption {
    margin-bottom: 20px;
    font-weight: bold;
    color: #014e9e;
  }

  .date-picker {
    select,
    input {
      border: none;
      font-size: 16px;
      padding: 0 10px;
      outline: none;
    }

    display: flex;
    justify-content: space-between;

    .year {
      width: 100%;
    }
  }

  .actions > * {
    margin: 0 10px 0 10px;
  }
}


</style>
<style scoped>
@media  (max-width: 680px)  {
  .modal .box .button-set {
    flex-direction:column
  }
  .button-set .button:nth-child(2n) {
    margin-left:0;

  }
  .button-set .button {

    width:100%;
  }
}
[data-modal-close] {
  position:static;
  float:right;
}
.error {
  color: #e84c3d;
  margin-top:10px;
}
.error-gray {
  color: #929292;
  margin-top:10px;
}
.hidden {
  display:none;
}
</style>
